import * as React from "react";
import classNames from "classnames";
import {ComponentProps} from "react";
import {twMerge} from "tailwind-merge";
import {CarouselContext} from "./Context";

const navigeteClassNames = classNames(
  "absolute bg-slate-50 w-10 aspect-square flex items-center justify-center shadow",
  "cursor-pointer font-bold rounded-full text-lg z-10 top-1/2 -translate-y-1/2",
);

export const NavigationArrow = ({left, className, children, ...restProps}: ComponentProps<"div"> & {left?: boolean}) => {
  const {navigate} = React.useContext(CarouselContext);

  return (
    <div
      className={
        twMerge(
          classNames(
            navigeteClassNames, 
            {
              "left-1 rotate-180": left,
              "right-1": !left
            }
          ),
          className
        )
      }
      onClick={() => navigate(left ? -1 : 1)}
      {...restProps}
    >
      {children || "‣"}
    </div>
  )
}

const Dot = ({active, ...restProps}: {active?: boolean} & React.ComponentProps<"div">) => {
  return (
    <div className={
      twMerge(
        classNames(
          "w-2 h-2 rounded-full transition-colors cursor-pointer",
          {
            "bg-primary-600": active,
            "border border-gray-300 bg-gray-50": !active
          },
        ),
      )
    }
    {...restProps}/>
  )
}

export const Dots = () => {
  const {slidesCount, goto, page} = React.useContext(CarouselContext);

  return (
    <div className="flex justify-center space-x-2">
      {Array(slidesCount).fill(1).map((_, i) => (
        <Dot 
          key={i} 
          onClick={() => goto(i)}
          active={page.idx === i}/>
      ))}
    </div>
  )
}
